import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, CategoryDto, DynamicFormDto, DynamicPayloadDto, EmployerDto, MemberDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpEmployerService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/employer', authService);
	}
	public getForm(): Observable<DynamicFormDto> {
		return super.doGet(true, "/form");
	}
	public get(id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${id}`);
	}
	public create(payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/`, payload);
	}
	public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public getAll(includeMemberCount=false): Observable<EmployerDto[]> {
		return super.doGet(true, `/?includeMemberCount=${includeMemberCount}`);
	}

	public getFull(id: number): Observable<EmployerDto> {
		return super.doGet(true, `/${id}/full`);
	}
}
